import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import ButtonBS from '../../../components/common/ButtonBS';
import PageLayout2 from '../../../components/common/PageLayout/PageLayout2';
import Checkbox from '../../../components/common/CustomCheckbox';
import translations from '../../../middlewares/i18n/StateWarnings.json';
import LoadingAnimation from '../../../styles/assets/LoadingScreen_Symbol_F.webm';

import { getDirectionFromList } from '../../../actions/viewActions';
import { fetchStateWarnings, acknowledgeStateWarnings } from '../../../actions/stateWarningsActions';
import { cancelOperation } from '../../../actions/authActions';
import { removeStyleTags, disableLinks } from '../../../actions/termsAndConditions';

import { usStatesAndTerritories } from '../../../helpers/us_states';

import '../../../styles/StateWarnings/StateWarnings.css';

class StateWarnings extends PureComponent {
  state = { acknowledged: false };

  componentDidMount() {
    this.props.actions.fetchStateWarnings();
  }

  handleCancel = () => {
    this.props.actions.cancelOperation();
  };

  handleContinue = () => {
    if (!this.state.acknowledged) {
      const el = document.getElementById('state-warnings-checkbox-row');
      el.classList.add('shake');
      setTimeout(() => el.classList.remove('shake'), 1000);
      return;
    }
    const { items } = this.props;
    this.props.actions.acknowledgeStateWarnings((items || []).map(w => w.id));
    this.props.actions.push(this.props.actions.getDirectionFromList());
  };

  render() {
    const { client, items, language } = this.props;
    const { acknowledged } = this.state;

    if (!items || items.length === 0) {
      return (
        <div className="bs-body loading-cont">
          <div className='loading-vid'>
            <video controls={false} autoPlay loop width='800' height='800'>
              <source src={LoadingAnimation} type='video/webm'/>
            </video>
          </div>
          <h4 className="no-margin loading-mes">Loading<span>.</span><span>.</span><span>.</span></h4>
        </div>
      );
    }

    const i18n = translations[language] || translations.en;
    const hasLimits = !!(client && client.state_notice
      && client.state_notice.state_notice_limits
      && client.state_notice.state_notice_limits.length > 0);
    const warningHtml = (items || []).map((w) => {
      let parsed;
      try { parsed = JSON.parse(w.warning_text); }
      catch (e) { console.error('StateWarnings: warning_text is not valid JSON', e); return ''; }
      const body = parsed[language] || parsed.en;
      if (!body) { console.error('StateWarnings: no usable language in warning_text'); return ''; }
      return disableLinks(removeStyleTags(body));
    }).join('');

    return (
      <PageLayout2 big={false} phone={true}>
        <div className="state-warnings__content">
          <div className="attention-logo state-warnings__logo" />
          <h6 className="state-warnings__title">{i18n.title}</h6>
          <p className="state-warnings__subtitle">
            {i18n.stateRestrictionSubtitle1} {this.getStateName()} {i18n.stateRestrictionSubtitle2}
          </p>
          {hasLimits && (
            <div className="state-warnings__limits-cards">
              <div>
                <h4 className="state-warnings__limits-title">{i18n.restrictions}</h4>
                <div className="state-warnings__divider" />
                {client.state_notice.state_notice_limits.map((limit, index) => (
                  <p className="state-warnings__limits-item" key={index}>{limit.disclaimer}</p>
                ))}
              </div>
            </div>
          )}
          <div className={`state-warnings__notice-section${hasLimits ? '' : ' state-warnings__notice-section--no-limits'}`}>
            <h6 className="state-warnings__title">{i18n.noticeFromYourState}</h6>
            <div className="state-warnings__card">
              <div className="state-warnings__card-body" dangerouslySetInnerHTML={{ __html: warningHtml }}/>
            </div>
            <div id="state-warnings-checkbox-row" className="state-warnings__checkbox-row animated">
              <Checkbox
                id="state-warnings-acknowledge"
                initialChecked={false}
                onChange={(val) => this.setState({ acknowledged: val })}
              />
              <p>{i18n.acknowledgement}</p>
            </div>
          </div>
          <div className="state-warnings__buttons">
            <ButtonBS v2 className="v2--red" content={i18n.cancel} onClick={this.handleCancel} />
            <ButtonBS
              v2
              className={acknowledged ? "v2--red" : "v2--gray"}
              content={i18n.continue}
              onClick={this.handleContinue}
            />
          </div>
        </div>
      </PageLayout2>
    );
  }

  getStateName() {
    const { client, items } = this.props;
    const stateCode = (client && client.state_notice && client.state_notice.state)
      || (items && items.length > 0 ? items[0].state : null);
    if (!stateCode) return null;
    return usStatesAndTerritories[stateCode] || stateCode;
  }
}

function mapStateToProps(state) {
  return {
    language: state.i18n.language.current,
    items:    state.stateWarnings.items,
    client:   state.client,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchStateWarnings,
      acknowledgeStateWarnings,
      cancelOperation,
      push,
      getDirectionFromList,
    }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StateWarnings);